/**
 * BE `invalid_fields` key → the finder Add/Edit form's field name. Only fields
 * that have an inline error slot in the sheet are mapped; unmapped keys (e.g.
 * schedule_id, gender_id) fall through to the summary toast.
 */
export const FINDER_BE_TO_FORM_FIELD: Record<string, string> = {
  // SN-8294 — "not in any competition for this sport": the form shows its own
  // guidance under the Sport field rather than the raw message.
  sport_id: 'sportId',
  player_type_id: 'positionId',
  skill_level: 'skillLevel',
  bio: 'bio',
  available_days: 'days',
  available_times: 'times',
  charge_rate: 'charge_rate',
  // SN-8295 — the card's own location.
  'location.country_id': 'countryId',
  'location.province_id': 'provinceId',
  'location.city': 'city',
}

/** BE `invalid_fields` key → human title used in the summary toast. */
export const FINDER_BE_TO_FIELD_TITLE: Record<string, string> = {
  player_type_id: 'Position',
  skill_level: 'Skill Level',
  bio: 'Bio',
  available_days: 'Available Days',
  available_times: 'Available Times',
  charge_rate: 'Rate',
  gender_id: 'Gender',
  schedule_id: 'Competition',
  sport_id: 'Sport',
  'location.country_id': 'Country',
  'location.province_id': 'State/Province',
  'location.city': 'City',
}
